import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import styles from './styles.module.css';
import parts from '../moduleCard/moduleParts.module.css';
import DateChip from '../moduleCard/DateChip';
import MealCard from './MealCard';
import { countItems, formatDate } from './mealPlanModel';

/**
 * Versões anteriores do plano (só leitura): data, título e resumo; cada uma
 * abre no lugar para conferir as refeições. Com `onEdit`, o profissional
 * pode corrigir uma versão antiga sem torná-la a vigente.
 */
const MealPlanVersionList = ({ versions, appointmentId, onEdit }) => {
  const [openId, setOpenId] = useState(null);

  if (!versions || versions.length === 0) return null;

  return (
    <div className={styles.versions}>
      <span className={parts.sectionLabel}>Versões anteriores</span>
      <div className={parts.scrollList}>
        {versions.map((plan) => {
          const open = String(openId) === String(plan.id);
          const sameAppointment = appointmentId && String(plan.appointmentId) === String(appointmentId);
          return (
            <div key={plan.id} className={parts.item}>
              <div className={styles.versionHead}>
                <DateChip label={formatDate(plan.createdAt)} compact />
                <span className={parts.itemTitle}>{plan.title || 'Plano alimentar'}</span>
                <span className={parts.muted}>
                  {plan.meals.length} {plan.meals.length === 1 ? 'refeição' : 'refeições'}, {countItems(plan.meals)} itens
                  {sameAppointment && ' · deste atendimento'}
                </span>
                <div className={styles.versionActions}>
                  {onEdit && (
                    <Tooltip title="Corrigir esta versão">
                      <IconButton size="small" onClick={() => onEdit(plan)}>
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title={open ? 'Recolher' : 'Ver refeições'}>
                    <IconButton size="small" onClick={() => setOpenId(open ? null : plan.id)}>
                      {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
              {open && (
                <div className={styles.versionBody}>
                  <div className={styles.meals}>
                    {plan.meals.map((meal) => <MealCard key={meal.key} meal={meal} />)}
                  </div>
                  {plan.guidelines && (
                    <div className={styles.guidelines}>
                      <span className={parts.sectionLabel}>Orientações gerais</span>
                      <span className={parts.itemText}>{plan.guidelines}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MealPlanVersionList;
